import clsx from "clsx";
import React from "react";

interface ModalFooterProps {
	children?: React.ReactNode;
	classes?: string;
}

export function ModalFooter({ classes, children }: ModalFooterProps) {
	if (!children) {
		return null;
	}

	return (
		<footer className={clsx("flex modal__actions", classes)}>
			{children}
		</footer>
	);
}
